<template>
  <div class="body1">
    <div class="content">
      <div class="big-tit bold">TRAINING & SUPPORT</div>
    </div>
    <div class="content">
      <div class="border border-1">
        <!-- <img class="img1" src="../../assets/franchise-10.png"> -->
          <div class="title bold">1.Academic Training</div>
          <div class="txt-div">
            <p class="txt-p">Professional Recruitment and Selection of Teachers</p>
            <p class="txt-p">Comprehensive Teaching Training</p>
            <p class="txt-p">Program and classroom management protocols</p>
            <p class="txt-p">Curriculum support</p>
          </div>
      </div>
      <div class="border border-2">
          <div class="title bold">2.Operations</div>
          <div class="txt-div">
            <p class="txt-p">Operations Training and Guidelines</p>
            <p class="txt-p">Point of Sale Training</p>
            <p class="txt-p">Centre Manager Training</p>
            <p class="txt-p">Customer Service Training</p>
            <p class="txt-p">HR Support and Training</p>
            <p class="txt-p">Centre Renovation Support</p>
            <p class="txt-p">Centre Set Up Support</p>
          </div>
        <!-- <img class="img2" src="../../assets/franchise-11.png"> -->
      </div>
      <div class="border border-3">
        <!-- <img class="img1" src="../../assets/franchise-10.png" style="opacity: 0"> -->
          <div class="title bold">3.Sales&Marketing</div>
          <div class="txt-div">
            <p class="txt-p">Pre-marketing support</p>
            <p class="txt-p">Grand opening marketing support</p>
            <p class="txt-p">Local Marketing Plans</p>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../assets/style/index";
.body1{
  height: 650px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 58px;
  background: #6D43A1;
  
  .content{
    .media-content;
    max-width: 1000px;
    display: flex;
    // flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .big-tit{
      color: #fff;
      font-size: 40px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
      text-align: center;
      margin: 74px auto 65px;
    }
    .border{
      position: relative;
      width: 313px;
      height: 449px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 15px;
      box-sizing: border-box;
      border: 2px solid #FFFFFF;
      .title{
        width: 260px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        color: white;
        font-size: 24px;
        font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
        background: #6D43A1;
        position: absolute;
        top: -14px;
        left: 50%;
        transform: translateX(-50%);
      }
      .txt-div{
        width: 100%;
        box-sizing: border-box;
        padding: 46px 20px 0 70px;
        .txt-p{
          color: #FFFFFF;
          font-size: 16px;
          font-weight: 300;
          line-height: 24px;
          position: relative;
          margin-bottom: 25px;
        }
        .txt-p::before{
          content: "";
          display: block;
          width: 9px;
          height: 9px;
          position: absolute;
          top: 4px;
          left: -40px;
          border-radius: 50px;
          background: #FFCC00;
        }
      }
    }
  }
  .bold{
    font-weight: bold;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/franchise/e-body3.vue